import { render, staticRenderFns } from "./Disabilities.vue?vue&type=template&id=43ca65fd&scoped=true"
import script from "./Disabilities.vue?vue&type=script&lang=js"
export * from "./Disabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ca65fd",
  null
  
)

export default component.exports